/* @generated */

// ../src/avatar/avatar/avatar.tsx
import classNames from "classnames";
import * as React5 from "react";
import { PersonFill } from "@dropbox/dig-icons/assets";

// ../src/_global/sizes.tsx
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getLegacyComponentSize = (size) => {
  const mapping = deprecationMap.find(([newVal, _deprecatedVal]) => size === newVal);
  if (mapping !== void 0) {
    return mapping[1];
  }
  return size;
};
var getMigratedComponentSize = (size) => {
  const mapping = deprecationMap.find(([_newVal, deprecatedVal]) => size === deprecatedVal);
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/avatar/avatar/avatar-color-util.ts
var avatarPalettes = [
  {
    background: "var(--dig-color__identity__yellow)",
    foreground: "var(--dig-color__identity__on-yellow)"
  },
  {
    background: "var(--dig-color__identity__orange)",
    foreground: "var(--dig-color__identity__on-orange)"
  },
  {
    background: "var(--dig-color__identity__red)",
    foreground: "var(--dig-color__identity__on-red)"
  },
  {
    background: "var(--dig-color__identity__cyan)",
    foreground: "var(--dig-color__identity__on-cyan)"
  },
  {
    background: "var(--dig-color__identity__magenta)",
    foreground: "var(--dig-color__identity__on-magenta)"
  },
  {
    background: "var(--dig-color__identity__blue)",
    foreground: "var(--dig-color__identity__on-blue)"
  },
  {
    background: "var(--dig-color__identity__purple)",
    foreground: "var(--dig-color__identity__on-purple)"
  }
];
function avatarColorPalette(inputString) {
  const HASH_MULTIPLIER = 5381;
  const hashingString = inputString ? inputString : Math.random().toString(36).slice(2);
  let hash = HASH_MULTIPLIER * hashingString.length;
  for (let i = 0; i < hashingString.length; i++) {
    hash = Math.abs(hashingString.charCodeAt(i) + ((hash << 6) + (hash << 16) - hash));
  }
  return avatarPalettes[hash % avatarPalettes.length];
}
function avatarColorForUserIdentifier(inputString) {
  return avatarColorPalette(inputString).background;
}

// ../src/avatar/avatar/useSquircleClipPath.tsx
import * as React3 from "react";

// ../src/avatar/avatar/squircle-clip.tsx
import * as React from "react";
var SquircleClip = ({ id }) => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "0",
      height: "0",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "digAvatarClip",
      "aria-hidden": "true",
      style: {
        // Make sure the clip path is taken out of the DOM flow. It's already 0x0 and contains no visible pixels, so
        // an `absolute` position should be all we need.
        position: "absolute"
      }
    },
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "objectBoundingBox", id }, /* @__PURE__ */ React.createElement("path", { d: "M0.5,0 C0.164,0,0,0.164,0,0.5 C0,0.836,0.164,1,0.5,1 C0.836,1,1,0.836,1,0.5 C1,0.164,0.836,0,0.5,0" })))
  );
};

// ../src/avatar/avatar/useSquircleClipPath.tsx
import { useUniqueId } from "@dropbox/dig-components/hooks";

// ../src/avatar/avatar/avatar-context.tsx
import * as React2 from "react";
var AvatarContext = React2.createContext({
  hasLegacyRounding: false,
  clipPathUrl: null
});
var _PrivateAvatarPropContext = React2.createContext({});

// ../src/avatar/avatar/useSquircleClipPath.tsx
var useSquircleClipPath = () => {
  const context = React3.useContext(AvatarContext);
  const defaultId = useUniqueId({ prefix: "dig-clip-path" });
  if (context.hasLegacyRounding) {
    return {
      clipPathUrl: null,
      clipPath: null
    };
  }
  if (context.clipPathUrl === null) {
    if (defaultId.length === 0) {
      return {
        clipPathUrl: null,
        clipPath: null
      };
    }
    return {
      clipPathUrl: `url('#${defaultId}')`,
      clipPath: /* @__PURE__ */ React3.createElement(SquircleClip, { id: defaultId })
    };
  }
  return {
    clipPathUrl: context.clipPathUrl,
    clipPath: null
  };
};

// ../src/_global/withContextInjection.tsx
import * as React4 from "react";
function withContextInjection(component, context) {
  const Component = component;
  const ComponentWithInjection = (props) => {
    const ctx = React4.useContext(context);
    return /* @__PURE__ */ React4.createElement(Component, { ...props, ...ctx });
  };
  ComponentWithInjection.displayName = "ContextInjection";
  return ComponentWithInjection;
}

// ../src/avatar/avatar/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var avatar = _7a468({ defaultClassName: "dig-1hapyr81_21-1-1", variantClassNames: { size: { xsmall: "dig-1hapyr82_21-1-1", small: "dig-1hapyr83_21-1-1", medium: "dig-1hapyr84_21-1-1", large: "dig-1hapyr85_21-1-1" }, isGuest: { true: "dig-1hapyr86_21-1-1" }, hasNoOutline: { true: "dig-1hapyr87_21-1-1" }, withImage: { true: "dig-1hapyr88_21-1-1" }, isModern: { true: "dig-1hapyr89_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ size: "xsmall", hasNoOutline: true }, "dig-1hapyr8a_21-1-1"], [{ size: "small", hasNoOutline: true }, "dig-1hapyr8b_21-1-1"], [{ size: "medium", hasNoOutline: true }, "dig-1hapyr8c_21-1-1"], [{ size: "large", hasNoOutline: true }, "dig-1hapyr8d_21-1-1"], [{ isModern: true, hasNoOutline: true }, "dig-1hapyr8e_21-1-1"]] });
var avatarClipPath = "var(--dig-1hapyr80_21-1-1)";
var avatarImage = _7a468({ defaultClassName: "dig-1hapyr8q_21-1-1", variantClassNames: { isGuest: { true: "dig-1hapyr8r_21-1-1" }, isInactive: { true: "dig-1hapyr8s_21-1-1" }, isModern: { true: "dig-1hapyr8t_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ isGuest: true, isModern: true }, "dig-1hapyr8u_21-1-1"]] });
var avatarModernInner = "dig-1hapyr8v_21-1-1";
var avatarText = _7a468({ defaultClassName: "dig-1hapyr8f_21-1-1", variantClassNames: { isGuest: { true: "dig-1hapyr8g_21-1-1" }, isInactive: { true: "dig-1hapyr8h_21-1-1" }, isNumber: { true: "dig-1hapyr8i_21-1-1" }, size: { xsmall: "dig-1hapyr8j_21-1-1", small: "dig-1hapyr8k_21-1-1", medium: "dig-1hapyr8l_21-1-1", large: "dig-1hapyr8m_21-1-1" }, isModern: { true: "dig-1hapyr8n_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ isNumber: true, isInactive: true }, "dig-1hapyr8o_21-1-1"], [{ isGuest: true, isInactive: true }, "dig-1hapyr8p_21-1-1"]] });

// ../src/avatar/avatar/avatar.tsx
import { assignInlineVars } from "@vanilla-extract/dynamic";
var _Avatar = ({
  className,
  children,
  src,
  srcSet,
  alt,
  size: _size = "medium",
  isInactive = false,
  hasNoOutline = false,
  isGuest = false,
  colorPalette,
  style,
  hasImageBackgroundColor = false,
  backgroundColor,
  ...rest
}) => {
  const size = getMigratedComponentSize(_size);
  const [imageFailedToLoad, setImageFailedToLoad] = React5.useState(false);
  const handleError = () => setImageFailedToLoad(true);
  const guestPalette = React5.useMemo(() => {
    return avatarColorPalette();
  }, []);
  const { clipPathUrl, clipPath } = useSquircleClipPath();
  const isModernAvatar = clipPathUrl !== null;
  const computedPalette = React5.useMemo(() => {
    if (backgroundColor) {
      return legacyColorToPalette(backgroundColor);
    }
    if (isGuest && colorPalette === void 0) {
      return guestPalette;
    }
    if (colorPalette) {
      return colorPalette;
    }
    return avatarColorPalette(children ? children.toString() : "");
  }, [backgroundColor, children, colorPalette, guestPalette, isGuest]);
  const hasActiveImage = (src || srcSet) && !imageFailedToLoad && !isGuest;
  const hasCount = children && typeof children === "number";
  const cls = classNames(
    className,
    "dig-Avatar",
    `dig-Avatar--${getLegacyComponentSize(size)}`,
    avatar({
      size,
      hasNoOutline,
      withImage: !!hasActiveImage,
      isModern: isModernAvatar,
      isGuest
    }),
    {
      "dig-Avatar--medium": size === "medium",
      "dig-Avatar--hasNoOutline": hasNoOutline,
      "dig-Avatar--withImage": hasActiveImage,
      "dig-Avatar--isGuest": isGuest,
      "dig-Avatar--isInactive": isInactive,
      "dig-Avatar--modern": isModernAvatar
    }
  );
  const imgCls = classNames(
    {
      "dig-Avatar-image": true,
      "dig-Avatar-image--isInactive": isInactive,
      "dig-Avatar-image--modern": isModernAvatar
    },
    // NOTE: we omit `isGuest` here because the `PersonFill` icon is rendered separately.
    avatarImage({ isInactive, isModern: isModernAvatar })
  );
  const textClass = classNames(
    {
      "dig-Avatar-text": true,
      "dig-Avatar-text--isInactive": isInactive,
      "dig-Avatar-text--isNumber": hasCount,
      [`dig-Avatar-text--size-${size}`]: true,
      "dig-Avatar-text--modern": isModernAvatar
    },
    avatarText({ isGuest, isInactive, isNumber: !!hasCount, isModern: isModernAvatar, size })
  );
  const useColorPalettes = !(hasCount || isInactive);
  const textStyles = {};
  const imgStyles = {};
  let wrapperStyles = {};
  if (useColorPalettes) {
    textStyles.background = `${computedPalette.background}`;
    textStyles.color = `${computedPalette.foreground}`;
    wrapperStyles.color = `${computedPalette.foreground}`;
    if (hasImageBackgroundColor) {
      imgStyles.backgroundColor = `${computedPalette.background}`;
    }
  }
  if (isModernAvatar) {
    wrapperStyles = {
      ...wrapperStyles,
      ["--dig-avatar-clip-path"]: clipPathUrl,
      ...assignInlineVars({
        [avatarClipPath]: clipPathUrl
      })
    };
  }
  return /* @__PURE__ */ React5.createElement("div", { className: cls, "aria-label": alt, ...rest, style: { ...wrapperStyles, ...style } }, /* @__PURE__ */ React5.createElement(AvatarContentWrapper, { shouldWrap: isModernAvatar }, isGuest && /* @__PURE__ */ React5.createElement(
    PersonFill,
    {
      className: classNames(
        "dig-Avatar-image--isGuest",
        avatarImage({ isGuest, isModern: isModernAvatar }),
        {
          "dig-Avatar-image--modern": isModernAvatar
        }
      )
    }
  ), hasActiveImage ? /* @__PURE__ */ React5.createElement(
    "img",
    {
      alt,
      className: imgCls,
      src,
      onError: handleError,
      srcSet,
      style: imgStyles
    }
  ) : /* @__PURE__ */ React5.createElement("div", { className: textClass, style: textStyles, "data-testid": "digAvatarText" }, children)), clipPath);
};
_Avatar.displayName = "WrappedAvatar";
var Avatar = withContextInjection(
  _Avatar,
  _PrivateAvatarPropContext
);
Avatar.displayName = "Avatar";
var AvatarContentWrapper = React5.memo(
  ({ children, shouldWrap }) => {
    if (shouldWrap) {
      return /* @__PURE__ */ React5.createElement("div", { className: classNames("dig-Avatar--modern-inner", avatarModernInner) }, children);
    }
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, children);
  }
);
var legacyColorToPalette = (bgColor) => {
  const matchingPalette = avatarPalettes.find((palette) => palette.background === bgColor);
  if (matchingPalette) {
    return matchingPalette;
  }
  return {
    background: bgColor,
    // This is what `Avatar` was using as text color prior to the introduction of color palettes.
    foreground: "var(--dig-color__accent__on-accent)"
  };
};

// ../src/avatar/facepile/facepile.tsx
import * as React8 from "react";
import classNames2 from "classnames";

// ../src/avatar/facepile/context.tsx
import * as React6 from "react";
var defaultValue = {
  isInteractive: true,
  size: "standard",
  items: /* @__PURE__ */ new Set(),
  getIndex: () => -1,
  add: () => false,
  remove: () => false
};
var Context = React6.createContext(defaultValue);

// ../src/avatar/facepile/item.tsx
import * as React7 from "react";
import classnames from "classnames";
import { StylelessButton } from "@dropbox/dig-components/buttons";

// ../src/avatar/facepile/index.css.ts
import { createRuntimeFn as _7a4682 } from "@vanilla-extract/recipes/createRuntimeFn";
var facepile = "dig-jffck80_21-1-1";
var facepileItem = _7a4682({ defaultClassName: "dig-jffck81_21-1-1", variantClassNames: { size: { xsmall: "dig-jffck82_21-1-1", small: "dig-jffck83_21-1-1", medium: "dig-jffck84_21-1-1", standard: "dig-jffck85_21-1-1", large: "dig-jffck86_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });

// ../src/avatar/facepile/item.tsx
var Item = React7.forwardRef(
  ({
    alt,
    ["aria-label"]: ariaLabel,
    children,
    backgroundColor,
    colorPalette: _colorPalette,
    src,
    srcSet,
    className,
    style,
    isInactive,
    isGuest = false,
    hasImageBackgroundColor = false,
    onClick,
    ...rest
  }, ref) => {
    const [index, setIndex] = React7.useState(-1);
    const localRef = React7.useRef(null);
    const { size, getIndex, add, remove, isInteractive } = React7.useContext(Context);
    const convertedBgColor = backgroundColor ? legacyColorToPalette(backgroundColor) : void 0;
    const customPalette = _colorPalette || convertedBgColor;
    const colorPalette = customPalette || avatarColorPalette(index.toString());
    const cls = classnames("dig-Facepile-item", facepileItem({ size }), className, {
      "dig-Facepile-item--inactive": !isInteractive
    });
    React7.useImperativeHandle(
      ref,
      () => {
        return {
          getBoundingClientRect() {
            return localRef.current && localRef.current.getBoundingClientRect();
          }
        };
      },
      [localRef]
    );
    React7.useEffect(() => {
      add(localRef);
      return () => remove(localRef);
    }, [localRef, add, remove]);
    React7.useEffect(() => {
      setIndex(getIndex(localRef));
    }, [getIndex]);
    const computedProps = isInteractive ? { onClick } : { tabIndex: -1, role: "group" };
    return /* @__PURE__ */ React7.createElement(
      StylelessButton,
      {
        ref: localRef,
        className: cls,
        style,
        ...rest,
        ...computedProps,
        "aria-label": ariaLabel != null ? ariaLabel : alt
      },
      isGuest ? /* @__PURE__ */ React7.createElement(
        Avatar,
        {
          alt: "",
          role: "presentation",
          size,
          isGuest: true,
          colorPalette: customPalette,
          isInactive
        }
      ) : /* @__PURE__ */ React7.createElement(
        Avatar,
        {
          alt: "",
          size,
          role: "presentation",
          colorPalette,
          src,
          srcSet,
          isInactive,
          hasImageBackgroundColor
        },
        children
      )
    );
  }
);
Item.displayName = "Item";

// ../src/avatar/facepile/facepile.tsx
var Facepile = ({
  children,
  size: _size = "medium",
  isInteractive = true
}) => {
  const size = getMigratedComponentSize(_size);
  const [items, setItems] = React8.useState(/* @__PURE__ */ new Set());
  const context = React8.useContext(AvatarContext);
  const { clipPathUrl, clipPath } = useSquircleClipPath();
  const getIndex = React8.useCallback(
    (elementRef) => {
      if (!elementRef || !elementRef.current)
        return -1;
      const arr = Array.from(items.values());
      return arr.indexOf(elementRef.current);
    },
    [items]
  );
  const add = React8.useCallback(
    (elementRef) => {
      if (!elementRef || !elementRef.current)
        return;
      setItems(items.add(elementRef.current));
    },
    [items]
  );
  const remove = React8.useCallback(
    (elementRef) => {
      if (!elementRef || !elementRef.current)
        return;
      const deleted = items.delete(elementRef.current);
      if (deleted)
        setItems(items);
    },
    [items]
  );
  const defaultValue2 = { size, items, getIndex, add, remove, isInteractive };
  const cls = classNames2(
    "dig-Facepile",
    facepile,
    `dig-Facepile--${getLegacyComponentSize(size)}`,
    {
      "dig-Facepile--medium": size === "medium"
    }
  );
  return /* @__PURE__ */ React8.createElement(Context.Provider, { value: defaultValue2 }, /* @__PURE__ */ React8.createElement(AvatarContext.Provider, { value: { hasLegacyRounding: context.hasLegacyRounding, clipPathUrl } }, /* @__PURE__ */ React8.createElement("div", { className: cls }, React8.Children.toArray(children).reverse(), clipPath)));
};
Facepile.Item = Item;
Facepile.displayName = "Facepile";
export {
  Avatar,
  AvatarContext,
  Facepile,
  SquircleClip,
  _PrivateAvatarPropContext,
  avatarColorForUserIdentifier,
  avatarColorPalette,
  legacyColorToPalette,
  useSquircleClipPath
};
